<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container" ref="datalist">
    <data-view-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />
    <div
      class="flex flex-wrap-reverse items-center flex-grow justify-between vs-div-header"
    >
      <div class="flex flex-wrap-reverse items-center data-list-btn-container">
        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4">
          <div
            class="p-2 ml-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full"
          >
            <span class="mr-2">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Delete</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Archive</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon
                  icon="FileIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Print</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon
                  icon="SaveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Another Action</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>

        <div class="action-btn cursor-pointer flex items-center justify-center">
          <div
            class="text-center preview-quiz p-3 mr-4 cursor-pointer text-sm text-primary border border-solid border-primary"
            @click="openQuiz"
          >
            <span class="ml-2 text-base text-primary">Preview Quiz</span>
          </div>
          <feather-icon
            @click.stop="editShow(action_show)"
            icon="EditIcon"
            svgClasses="w-7 h-7 hover:text-primary stroke-current"
            v-if="getPermission()"
          />
        </div>

        <!-- ADD NEW -->

        <!-- <add-edit-new-questionnaire
          :all_data="all_question"
          @reloadItems="getQuestionnaire"
        /> -->
        <div
          class="btn-add-new text-center p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
          @click="openForm"
          v-if="getPermission()"
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-primary">Add New</span>
        </div>
        <div>
          <v-select
            :clearable="false"
            :options="[
              { label: 'Active', value: 'active' },
              { label: 'Draft', value: 'draft' },
            ]"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            placeholder="Status"
            style="width: 150px !important"
            @input="changeStatus"
            v-model="db_status"
          />
        </div>
      </div>

      <!-- ITEMS PER PAGE -->
      <!-- <vs-dropdown
        vs-trigger-click
        class="cursor-pointer mb-4 mr-4 items-per-page-handler"
      > -->
      <!-- <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                products.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : products.length
              }}
              of {{ queriedItems }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div> -->
      <!-- <vs-button
          class="btn-drop"
          type="line"
          color="primary"
          icon-pack="feather"
          icon="icon-chevron-down"
        ></vs-button>
        <vs-dropdown-menu>
          <vs-dropdown-item @click="itemsPerPage = 4">
            <span>4</span>
          </vs-dropdown-item>
          <vs-dropdown-item @click="itemsPerPage = 10">
            <span>10</span>
          </vs-dropdown-item>
          <vs-dropdown-item @click="itemsPerPage = 15">
            <span>15</span>
          </vs-dropdown-item>
          <vs-dropdown-item @click="itemsPerPage = 20">
            <span>20</span>
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown> -->
    </div>
    <div class="flex-grow justify-between">
      <div class="data-list-btn-container">
        <!-- ACTION - DROPDOWN -->

        <vs-list>
          <draggable
            :list="all_question"
            class="cursor-move"
            @change="changePosition"
          >
            <!-- <transition-group> -->
            <vs-list-item
              class="body-div list-item"
              :key="indextr"
              v-for="(tr, indextr) in all_question"
            >
              <div class="action-btn" v-if="action_show == true">
                <feather-icon
                  @click.stop="editData(tr, indextr)"
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  class="cursor-pointer"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2 cursor-pointer"
                  @click.stop="deleteData(tr)"
                />
              </div>
              <div class="question">
                <p class="product-name font-medium truncate">
                  {{ indextr + 1 }}. {{ tr.question }}
                </p>
              </div>

              <div :key="index" v-for="(option, index) in tr.options">
                <div style="display: flex; font-size: 16px">
                  <div class="option-span mr-4"></div>
                  {{ option.text }}
                </div>
              </div>
              <!-- <vs-collapse>
                <vs-collapse-item> -->
              <div>
                <add-edit-new-questionnaire
                  :all_data="all_question"
                  @reloadItems="getQuestionnaire"
                  :activePrompt="tr.is_collapse"
                  @cancel="cancelForm"
                  @changeQuestion="changeQuestion"
                  @changeOptionText="changeOptionText"
                />
              </div>

              <!-- </vs-collapse-item>
              </vs-collapse> -->
            </vs-list-item>
            <!-- </transition-group> -->
          </draggable>
        </vs-list>
        <div class="flex m-4">
          <add-edit-new-questionnaire
            :all_data="all_question"
            @reloadItems="getQuestionnaire"
            :activePrompt="is_add_new"
            @cancel="cancelForm"
          />
        </div>

        <!-- <add-edit-new-questionnaire
          :all_data="all_question"
          @reloadItems="getQuestionnaire"
          :activePrompt="is_show_form"
          @cancel="cancelForm"
        /> -->
      </div>
    </div>
  </div>
</template>

<script>
import DataViewSidebar from "../ui-elements/data-list/DataViewSidebar.vue";
import moduleDataList from "@/store/data-list/moduleDataList.js";
import AddEditNewQuestionnaire from "../apps/health-tracker2/AddEditNewQuestionnaire.vue";
import DataProvider from "../../services/data-provider";
import vSelect from "vue-select";
import { bus } from "../../main";
import draggable from "vuedraggable";

export default {
  components: {
    DataViewSidebar,
    AddEditNewQuestionnaire,
    vSelect,
    draggable,
  },
  data() {
    return {
      selected: [],
      all_question: [],
      items_data: [],
      user_permissions: {},
      user_role: "",
      delete_data: "",
      is_add_new: false,
      itemsPerPage: 10,
      isMounted: false,
      is_show_form: false,
      action_show: false,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      open_index: 0,
      edit_data: "",
      flag: true,
      db_status: "",
      status: "",
      old_db_status: "",
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },

    products() {
      return this.$store.state.dataList.products;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.products.length;
    },
  },
  methods: {
    getPermission() {
      console.log(this.$route);
      if (this.user_role == "Owner") return true;
      if (this.user_permissions[this.$route.name]) {
        console.log(this.user_permissions[this.$route.name]);
        return this.user_permissions[this.$route.name]["write"];
      }
    },
    editShow() {
      this.action_show = !this.action_show;
    },
    changeQuestion(event) {
      console.log(event);
      this.all_question[this.open_index].question = event;
    },
    changeOptionText(event) {
      console.log(event);
      this.all_question[this.open_index].options[event.index].text = event.text;
    },
    openQuiz() {
      this.$router.push("/pages/quiz");
    },
    changePosition() {
      if (this.getPermission()) {
        this.$vs.loading();
        console.log("changePosition", this.all_question);
        let question_data = this.all_question.filter(
          (v) => delete v.is_collapse
        );
        console.log(question_data);
        DataProvider.updateFirestoreCloudData(
          "/health_tracker_all_question/",
          question_data
        ).then(
          (data) => {
            this.$vs.loading.close();
            console.log("Data:", data);
          },
          (error) => {
            DataProvider.sendSentryErrorLog(err)
            this.$vs.loading.close();
          }
        );
      } else {
        this.$vs.notify({
          color: "warning",
          title: "Access denied!",
        });
        this.all_question = this.all_questionnaire_data.map((res) => {
          return { ...(res.is_collapse = false), ...res };
        });
      }
    },
    openForm() {
      this.is_add_new = true;
      bus.$emit("edit_cancel", false);
      this.all_question = this.all_question.map((res) => {
        return { ...(res.is_collapse = false), ...res };
      });
      window.scrollTo(
        0,
        document.querySelector(".content-wrapper").scrollHeight
      );
      // this.$nextTick(() => {
      //   this.$parent.$el.scrollTop = this.$parent.$el.scrollHeight;
      // });
    },
    cancelForm(e) {
      console.log("cancelForm", e);
      this.is_show_form = false;
      this.is_add_new = false;
      console.log(this.edit_data);
      this.getQuestionnaire();
      // this.all_question = this.all_questionnaire_data.map((res) => {
      //   return { ...(res.is_collapse = false), ...res };
      // });
    },
    changeStatus(event) {
      if (this.getPermission()) {
        this.status = event.value;
        console.log(this.status);
        console.log(this.old_db_status);
        if (this.status != this.old_db_status) {
          this.$vs.dialog({
            type: "confirm",
            color: "primary",
            title: `Confirm Update status ${event.label}`,
            text: `This operation with make this questionnaire ${
              event.label == "Draft" ? "in Draft" : "live"
            }. Are you sure that you would like to proceed?`,
            accept: this.updateStatus,
            cancel: this.cancel,
            acceptText: "Update",
          });
        }
      } else {
        this.$vs.notify({
          color: "warning",
          title: "Access denied!",
        });
        //  this.status=this.old_db_status
      }
    },
    cancel() {
      console.log("cancel");
      this.status = this.old_db_status;
      this.db_status = this.old_db_status;
    },
    updateStatus() {
      this.old_db_status = this.status;
      DataProvider.updateData(
        "app_data",
        { status: this.status },
        "health_tracker"
      ).then(
        (re) => {
          console.log("res");
          this.$vs.notify({
            color: "success",
            title: "Updated!",
          });
        },
        (err) => {
          console.log("Err", err);
          DataProvider.sendSentryErrorLog(err)
          if (err.message.includes("403")) {
                this.$vs.notify({
                  color: "warning",
                  title: "Access denied!",
                });
              }
        }
      );
    },
    editData(data, index) {
      console.log(data);
      this.is_show_form = true;
      this.is_add_new = false;
      if (this.flag == true) {
        console.log("---------------------------");
        this.flag = false;
        this.edit_data = data;
      }
      this.all_question = this.all_question.map((res) => {
        return { ...(res.is_collapse = false), ...res };
      });
      bus.$emit("edit_questionnaire2", data, this.all_question);
      this.all_question[index].is_collapse = true;
      // this.all_question[this.open_index].is_collapse = false;
      this.open_index = index;
    },
    getQuestionnaire() {
      DataProvider.getDataFromFirestore("health_tracker").then(
        (res) => {
          console.log(res);
          if (res) {
            this.db_status = res.status ? res.status : "";
            this.old_db_status = res.status ? res.status : "";
            this.all_questionnaire_data = res.questions;
            this.all_question = res.questions.map((res) => {
              return { ...(res.is_collapse = false), ...res };
            });
            // this.$store.commit('setAllQuestionnaire',res.questions)
            console.log("this.all_question:", this.all_question);
          }
          //   this.arrangeData(res.questions);
        },
        (err) => {
          
          console.log(err);
          DataProvider.sendSentryErrorLog(err)
        }
      );
    },

    arrangeData(items_data) {
      var temparray = [],
        chunk = 10;
      var final_array = [];
      let len = items_data.length;
      for (let i = 1; i <= len; i++) {
        temparray.push(items_data[i - 1]);
        if (i % chunk == 0) {
          final_array.push(temparray);
          temparray = [];
        } else if (i == len) {
          final_array.push(temparray);
          temparray = [];
        }
      }
      console.log(final_array);
      this.all_question = final_array;
      if (final_array.length != 0) {
        this.items_data = final_array[0];
      }
    },
    deleteRecord() {
      console.log("Del record", this.delete_data);
      delete this.delete_data.is_collapse;
      this.$vs.loading();
      DataProvider.deleteDataFromFirestore(
        "/health-tracker-questionnaire/",
        this.delete_data
      ).then(
        (res) => {
          console.log(res);
          this.showDeleteSuccess();
          this.$vs.loading.close();
          this.getQuestionnaire();
        },
        (err) => {
          console.log("error:", err);
          DataProvider.sendSentryErrorLog(err)
          this.$vs.loading.close();
          if (err.message.includes("403")) {
                this.$vs.notify({
                  color: "warning",
                  title: "Access denied!",
                });
              }
        }
      );
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Deleted!",
        text: "The selected item was successfully deleted.",
      });
    },
    deleteData(item) {
      this.is_show_form = false;
      this.delete_data = item;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete "${item.question}"`,
        accept: this.deleteRecord,
        acceptText: "Delete",
      });
    },
    // editData(data) {
    //   console.log("edit data", data);
    //   // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
    //   this.sidebarData = data;
    //   this.toggleDataSidebar(true);
    // },
    getOrderStatusColor(status) {
      if (status === "on_hold") return "warning";
      if (status === "delivered") return "success";
      if (status === "canceled") return "danger";
      return "primary";
    },
    getPopularityColor(num) {
      if (num > 90) return "success";
      if (num > 70) return "primary";
      if (num >= 50) return "warning";
      if (num < 50) return "danger";
      return "primary";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
  },
  created() {
    this.getQuestionnaire();
    // if (!moduleDataList.isRegistered) {
    //   this.$store.registerModule("dataList", moduleDataList);
    //   moduleDataList.isRegistered = true;
    // }
    // this.$store.dispatch("dataList/fetchDataListItems");
  },
  mounted() {
    this.isMounted = true;
    DataProvider.getCurrentAuthUser().then((res) => {
      console.log(res);
      this.user_role = res.claims.role;
      DataProvider.getData("users", res.claims.user_id).then(
        (data) => {
          console.log("data", data.permissions);
          this.user_permissions = data.permissions;
          console.log(this.user_permissions);
        },
        (err) => {
          DataProvider.sendSentryErrorLog(err)
        }
      );
    });
  },
};
</script>

<style lang="scss">
#data-list-list-view {
  .option-span {
    width: 15px;
    height: 15px;
    border: 1px solid;
    border-radius: 50px;
    margin: 5px;
  }
  .body-div {
    padding: 10px;
    .vs-list--slot {
      margin-left: 0px !important;
      width: 100%;
    }
  }
  .action-btn {
    position: absolute;
    right: 60px;
  }
  .preview-quiz {
    border-radius: 50px !important;
  }
  .vs-div-header {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
  .question {
    font-size: 20px;
  }
  .vs__selected {
    text-transform: capitalize;
  }
  // .list-item{
  //   transition: all 1s;
  // }
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          //   width: 100%;
          //   margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
